<template>
  <b-row>
    <b-col cols="12">
      <div
        class="bg-login auth-wrapper auth-v1 px-2"
      >
        <div class="py-2">

          <b-img
            class="logo-login"
            src="@/assets/images/logo/login.svg"
          />
          <!-- Login v1 -->
          <b-card
            style="background-color:rgba(36,36,36, 0.75); border: 1px solid #363636; border-radius: 32px;"
            class="mb-0"
          >
            <b-link class="brand-logo">

              <span style="font-size: 40px; color:#fff;">
                Login
              </span>
            </b-link>

            <b-card-title
              class="brand-logo"
              style="color:#fff; font-size:20px; text-shadow: 1px 1px #fff;"
            >
              Welcome to DRR Smart Dashboard
            </b-card-title>

            <!-- form -->
            <validation-observer
              ref="loginForm"
              #default="{invalid}"
            >
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent="login()"
              >

                <!-- username -->
                <b-form-group
                  label-for="username"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Username"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <b-img
                          width="18px;"
                          height="20px;"
                          src="@/assets/images/icons/login/User.svg"
                        />
                      </b-input-group-prepend>
                      <b-form-input
                        id="username"
                        v-model="username"
                        style="background-color: rgba(36,36,36, 0.75);"
                        name="login-username"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Username"
                        autofocus
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- password -->
                <b-form-group
                  style="background-color: rgba(36,36,36, 0.75);"
                >
                  <!-- <div class="d-flex justify-content-between">
                <label for="password">Password</label>
                <b-link :to="{name:'auth-forgot-password-v1'}">
                  <small>Forgot Password?</small>
                </b-link>
              </div> -->
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-input-group-prepend
                        is-text
                        class="form-control-merge"
                      >
                        <b-img
                          width="18px;"
                          height="20px;"
                          src="@/assets/images/icons/login/Lock.svg"
                        />
                      </b-input-group-prepend>
                      <b-form-input
                        id="password"
                        v-model="password"
                        :type="passwordFieldType"
                        style="background-color: rgba(36,36,36, 0.75);"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false:null"
                        name="login-password"
                        placeholder="Password"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- checkbox -->
                <b-form-group>
                  <b-form-checkbox
                    id="remember-me"
                    v-model="status"
                    name="checkbox-1"
                    style="color: #fff;"
                  >
                    <span style="color:#fff;">
                      Remember Me
                    </span>
                  </b-form-checkbox>
                </b-form-group>

                <!-- submit button -->
                <b-button
                  variant="primary"
                  type="submit"
                  block
                  :disabled="invalid"
                >
                  Log in
                </b-button>
              </b-form>
            </validation-observer>

          </b-card>
          <!-- /Login v1 -->
        </div>
      </div>
    </b-col>
  </b-row>

</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BRow, BCol,
  BInputGroup, BInputGroupAppend, BImg, BInputGroupPrepend, BFormCheckbox,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BInputGroupPrepend,
    BFormCheckbox,
    BCard,
    // BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      username: '',
      // sideImg: require('@/assets/images/pages/login/1.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.sideImg = require('@/assets/images/pages/login/1.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    if (this.$route.query.token) { this.loginToken() }
  },
  methods: {
    async login() {
      try {
        await this.$store.dispatch('auth/login', {
          username: this.username,
          password: this.password,
        })
        this.$swal.fire({
          position: 'center',
          icon: 'success',
          text: 'เข้าสู่ระบบสำเร็จ',
          showConfirmButton: false,
          timer: 1500,
        })
        if (this.username === 'drr-iot') {
          setTimeout(() => this.$router.push('/4g-total'), 1500)
        } else {
          setTimeout(() => this.$router.push('/'), 1500)
        }
      } catch (error) {
        this.$swal.fire({
          position: 'center',
          icon: 'error',
          text: 'กรุณาลองอีกครั้ง',
          showConfirmButton: false,
          timer: 1500,
        })
      }
    },
    async loginToken() {
      console.log(this.$route.query.token)
      try {
        await this.$store.dispatch('auth/loginToken', {
          token: this.$route.query.token,
        })
        this.$swal.fire({
          position: 'center',
          icon: 'success',
          text: 'เข้าสู่ระบบสำเร็จ',
          showConfirmButton: false,
          timer: 1500,
        })
        setTimeout(() => this.$router.push('/'), 1500)
      } catch (error) {
        this.$swal.fire({
          position: 'center',
          icon: 'error',
          text: 'กรุณาลองอีกครั้ง',
          showConfirmButton: false,
          timer: 1500,
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.logo-login{
  width: 100%;
  height: 111px;
  margin-bottom: 20px;
}

.bg-login{
  background-image: url("https://image.firsttech.co.th/car_stop/2022/1.svg");
  background-size: cover;
}
</style>
